import LeaveHistory from '../admin/LeaveHistory';
export default LeaveHistory;
